import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';

const client = new ApolloClient({
  link: createHttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT_URI,
  }),
  defaultOptions: {
    query: {
      fetchPolicy: 'cache-and-network'
    }
  },
  cache: new InMemoryCache({ addTypename: false }),
  ssrMode: false,
});
export default client